import { render, staticRenderFns } from "./SalesFlashChart.vue?vue&type=template&id=b354862c&"
import script from "./SalesFlashChart.vue?vue&type=script&lang=js&"
export * from "./SalesFlashChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports